import * as React from 'react';
import styled from "styled-components";
import {ConstWidth} from "../../../../config/styles_const/styles_const";

interface IProps {
}

// Tableレイアウトが崩れる場合に使う
const DefaultColgroup: React.FC<IProps> = (props) => {

    return(
        <colgroup>
            <StyledCol/>
            <col/>
            <StyledCol/>
            <col/>
        </colgroup>
    );

};

export default DefaultColgroup;

const StyledCol = styled.col`
    width: ${ConstWidth.TableThWidth};
`;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/table/default_colgroup.tsx